module.exports = __webpack_public_path__ + "img/withdraw-red.17572684.svg";